import React from "react";
import { Typography, Button, Row, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./sample-documents-view.scss";
import Preview from "../../../../common/preview/preview";

// import vatCertificatePreview from "../../../../assets/images/UAE-VAT1.pdf";
// import tradeLicensePreview from "../../../../assets/images/UAE-trade-license.pdf";
// import nationalIdPreview from "../../../../assets/images/UAE-VAT1.pdf";
// import drivingLicensePreview from "../../../../assets/images/UAE-VAT1.pdf";
// import passportPreview from "../../../../assets/images/UAE-VAT1.pdf";
// import visaPreview from "../../../../assets/images/UAE-VAT1.pdf";

const { Title } = Typography;

const countryCodeToPrefix = {
  AE: "UAE",
  TR: "TUR",
  KZ: "KSA",
};

// Sample doc type
// const sampleImageMap = {
//   VAT_Certificate: vatCertificatePreview,
//   trade_license_certificate: tradeLicensePreview,
//   national_id: nationalIdPreview,
//   driving_license: drivingLicensePreview,
//   passport: passportPreview,
//   visa: visaPreview,
// };

const sampleImageMap = {
  VAT_Certificate: "VAT",
  trade_license_certificate: "Trade_License",
  national_id: "National_ID",
  driving_license: "Driving_License",
  passport: "Passport",
  visa: "Visa",
  registration_certificate: "Truck_RC",
  trailer_rc: "Truck_RC",
};

const SampleDocumentPreviewModal = ({
  onClose,
  sampleType = "VAT_Certificate",
  countryCodeName = "AE",
}) => {
  console.log("countryCode", countryCodeName);
  // const fileUrl = sampleImageMap[sampleType] || null;

  const prefix = countryCodeToPrefix[countryCodeName] || "UAE";
  const imageName = sampleImageMap[sampleType] || "VAT";
  const fileUrl = `/ocr-sample-docs/${prefix}_${imageName}.png`;
  // const fileUrl = `/ocr-sample-docs/TUR_Passport.png`;
  return (
    <div className="sample-doc-modal-body">
      <Row justify="space-between" align="middle" className="modal-title">
        <Col>
          <Title
            level={5}
            style={{
              fontWeight: 500,
              fontSize: "18px",
              lineHeight: "150%",
              letterSpacing: 0,
              margin: 0,
            }}
          >
            Sample Document
          </Title>
        </Col>
        <Col>
          <Button
            icon={<CloseOutlined />}
            type="text"
            onClick={onClose}
            style={{
              width: "24px",
              height: "24px",
              fontSize: "16px",
              color: "var(--text, #000)",
            }}
          />
        </Col>
      </Row>
      <div className="sample-preview-modal">
        <Preview uploadedfile={fileUrl}></Preview>
      </div>
    </div>
  );
};

export default SampleDocumentPreviewModal;
